__turbopack_context__.v({
  "richtext": "rich-text-module__RPRDwa__richtext",
});
